/**
 * Универсальная функция для сортировки массива объектов по указанному ключу.
 * @param {Array} array - Массив объектов для сортировки.
 * @param {string} key - Ключ (свойство объекта), по которому выполняется сортировка.
 * @returns {Array} - Отсортированный массив.
 */
export function sortByKey(array: any[], key: string) {
  if (!Array.isArray(array)) {
    throw new Error("Первый аргумент должен быть массивом");
  }
  if (typeof key !== "string") {
    throw new Error("Второй аргумент должен быть строкой (название ключа)");
  }

  return array.sort((a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      throw new Error(`Ключ "${key}" отсутствует в одном из объектов`);
    }

    return String(a[key]).localeCompare(String(b[key]));
  });
}
